import React, { useEffect, useState } from "react";
import Styles from "../../styles.module.scss";
// import Button from "../../../../components/button";
import classnames from "classnames";
// import * as CONSTANTS from '../../../../utils/CONSTANTS'
import { Icon } from "@iconify/react";
// import TagLabel from '../../../../components/TagLabel';
import Headline5 from "../../../../components/headings/Headline5";
import devIcon from "../../../../assets/images/dev-icon.png";
import SideMenu from "../../sideMenu";
import { makeSideBarActive } from "../../../../utils/EllowUtils";
import * as CONSTANTS from "../../../../utils/CONSTANTS";
import DashboardHeader from "../../dashboardHeader";
import { convertFromRaw } from "draft-js";
import { convertToHTML } from "draft-convert";
import DOMPurify from "dompurify";
import Button from "../../../../components/button";
import { useLocation, useNavigate } from "react-router-dom";
import { getTestDetails } from "./services";

function ReferAndEarnDetails(props: any) {
  
  const navigate = useNavigate()
  const location = useLocation()
  const job: any = location.state ? location.state : null
  // const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {};
  const jobId = job && job.jobRole && job.jobRole.jobId
  // const [alert, setAlert] = useState<boolean>(false);
  // const [message, setMessage] = useState<string>("");
  const [data, setData] = useState<any>([]);
  const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 7);
  const loginId = localStorage.getItem('loginId') || '' 
  const [jobRole, setJobRole] = useState<any>()
  // const [jobDescription, setJobDescription] = useState<any>()
  const [jobRequirements, setJobRequirements] = useState<any>()
  const [jobResponsiblities, setJobResponsiblities] = useState<any>()    
  // const [testDetails, setTestDetails] = useState<any>()
  
    useEffect(() => {
        getJobandTestDetails(jobId, loginId)
    }, [jobId, loginId])
    

    const getJobandTestDetails = (jobId: string, loginId: string) => {
        getTestDetails(jobId, loginId).then((response: any) => {
            // setTestDetails(response.data[0].test_details)
            setJobRole(response.data[0].job_metadata.title)
            // setJobDescription(response.data[0].job_metadata.jobDescription)
            setJobRequirements(response.data[0].job_metadata.jobRequirements)
            setJobResponsiblities(response.data[0].job_metadata.jobResponsibilities)
            setData(response.data[0].job_metadata.coreSkills)
        })
    }

  // const displayNotification = (message: string) => {
  //   setMessage(message);
  //   setAlert(true);
  //   setTimeout(() => {
  //     setAlert(false);
  //   }, 4000);
  //   };
    
    const createMarkup = (html: any) => {
        if (html) {
            if (html && html.includes('{"blocks')) {
                let oldblockconverteddata = convertFromRaw(JSON.parse(html));
                let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);
    
                html = JSON.stringify(oldblockdataconvertedhtml);
                return {
                    __html: DOMPurify.sanitize(html).replace(/"/g, ''),
                };
            }
            if (html && (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>"))) {
                return {
                    __html: DOMPurify.sanitize(JSON.parse(html)).replace(/"/g, ''),
                };
            } else {
                html = "<p>" + html + "</p>";
                return {
                    __html: DOMPurify.sanitize(html).replace(/"/g, ''),
                };
            }
        }
      }

  return (
    <section className={Styles.dashboardWrapper}>
      <SideMenu menu={menu} />
      <div className={Styles.dashboardContent}>
              <DashboardHeader />
              <Headline5>{jobRole}</Headline5>

        <div className="contentBox">
          <div className="innerPadd48">
                      <div className={Styles.skillsTest}>
              <div className={Styles.skillsList}></div>
                          <div className={Styles.skillsHead}>
                              <Headline5>Required skills</Headline5>
                              <div className={Styles.referButton}>
                         <Button variant="primary" size="xxsmall"  onClick={()=> navigate('/referandearn-profile', {state:{jobRole: job && job.jobRole}})} >
                         <p >Refer a candidate</p>
                       </Button>
                       </div>
                          </div>

              <div className={Styles.skillsCards}>
                {data &&
                  data.map((item: any, key: number) => (
                    <div
                      className={
                        item.UserInfo
                          ? classnames(Styles.card, Styles.selected)
                          : Styles.card
                      }
                      key={key}
                    >
                      {item.UserInfo && item.UserInfo.is_passed && (
                        <Icon icon="akar-icons:circle-check" />
                      )}
                      {item.HackerEarth && item.HackerEarth.icon_url ? (
                        <img src={item.HackerEarth.icon_url} alt="icon"/>
                      ) : (
                        <img src={devIcon} alt="icon"/>
                      )}
                      <h3>{item.skillName}</h3>
                    </div>
                  ))}
                          </div>
                         <div>
              <Headline5>About the role</Headline5>
              <div className="preview" dangerouslySetInnerHTML={createMarkup(`We are looking for a ${jobRole}. The Candidate will be reporting directly to team leaders and will be working with cutting-edge technologies on world-class cloud platforms. The company helps businesses to experience noticeable growth by utilizing the tools, tech, and team that help boost ​ROI. This will be a long-term position for developers to experience rapid career growth.`)} ></div> 
            </div>
             <div>
              <Headline5>Job Responsibilities</Headline5>
                <div className="preview" dangerouslySetInnerHTML={createMarkup(jobResponsiblities)} ></div> 
            </div>
            <div>
              <Headline5>Requirements</Headline5>
              <div className="preview" dangerouslySetInnerHTML={createMarkup(jobRequirements)} ></div> 
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default ReferAndEarnDetails;
